import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header, MobileBottomNav } from '.';

export function PrivateLayout() {
  return (
    <div className="min-h-dvh bg-gray-50 grid grid-rows-[auto,1fr]">
      <div className="sticky top-0 z-50 bg-gray-50/80 backdrop-blur">
        <Header />
      </div>
      <main className="min-h-0 min-w-0 pb-16 sm:pb-0">
        {/* Spacer equal to header height to prevent overlap with fixed/sticky header */}
        <div aria-hidden="true" className="h-16" />
        <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 min-w-0">
          <Outlet />
        </div>
      </main>
      {/* Mobile Bottom Navigation */}
      <MobileBottomNav />
    </div>
  );
}
